import styled from 'styled-components';
import { Button } from '../../design/Button';

export const Back = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  height: 20px;
  width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PermissionButton = styled(Button)`
  margin-top: 5px;
  width: 100%;
  text-transform: uppercase;
`;

export const WhiteButton = styled(PermissionButton)`
  text-decoration: none;
  margin-top: 10px;
  background: white;
  color: #258BE0;
`;
